import { api } from "@/lib/api";

// EMAIL_RE - simple RFC-lite; UI safety net only, backend re-validates.
export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export async function joinWaitlist(email, source = "landing_hero") {
  const clean = (email || "").trim().toLowerCase();
  if (!EMAIL_RE.test(clean)) {
    const err = new Error("Please enter a valid work email.");
    err.code = "INVALID_EMAIL";
    throw err;
  }
  const { data } = await api.post("/waitlist", { email: clean, source });
  return data;
}
